(function () {
    'use strict';

    angular.module('app.charts')
        .directive('uaVsDuration', uaVsDuration);

    /* @ngInject */
    function uaVsDuration(SETTINGS, DataFactory) {
        return {
            restrict: 'E',
            template: '<div class="chart-header"><div><h3 class="chart-title">{{chartTitle}}<span class="sub">{{subtitle}}</span></h3></div><i class="icon-cloud-download" ng-click="exportChart()" title="Download chart"></i><i class="icon-doc" ng-if="chartDataKey" ng-click="downloadData()" title="Download data"></i></div><div class="cl-chart cl-chart-serial" id="{{id}}_chart"></div><p ng-if="source" class="source">Source: {{source}}​</p>',
            scope: {
                id: '@',
                chartData: '=',
                chartDataKey: '@',
                unit: '@',
                yLabel: '=',
                yLabelRotation: '=',
                chartTitle: '@',
                subtitle: '@',
                source: '@',
                logoUrl: '@',
                maxValue: "=",
                hideValueAxis: '@',
                showValueAxisUnit: '@',
                legendPosition: "@",
                colors: '=',
                highlightColor: '=',
                highlightedItem: '=',
                labelRotation: '=',
                labelOffset: '=',
                valuePosition: '@',
                stacked: '@'
            },
            link: link
        };

        function link(scope, elm, attrs) {

            var chart,
                hiddenChart,
                hiddenID = scope.id + '_hidden',
                exportW = 1200,
                exportH = 800,
                hasOneSeries = true,
                hideValueAxis = !!scope.hideValueAxis,
                showValueAxisUnit = !!scope.showValueAxisUnit,
                stacked = !!scope.stacked,
                valuePosition,
                yLabelRotation = 0,
                labelRotation = 0,
                labelOffset = 4,
                maxValue,
                legendPosition = 'right',
                legendAlign = '',
                unit = '',
                unitPosition = '',
                source = SETTINGS.CHARTS.SOURCE,
                colors = SETTINGS.PALETTE_EXT2
            ;

            if (angular.isUndefined(scope.valuePosition)) {
                valuePosition = 'hover';
            }

            if (angular.isDefined(scope.unit)) {
                unit = scope.unit;

                if (unit === '$' && unitPosition === '') {
                    unitPosition = 'left';
                }
            }

            if (angular.isDefined(scope.maxValue)) {
                maxValue = scope.maxValue;
            }

            if (angular.isDefined(scope.legendPosition)) {
                legendPosition = scope.legendPosition;

                if (legendPosition === 'bottom' && legendAlign === '') {
                    legendAlign = 'center';
                }
            }

            if (angular.isDefined(scope.yLabelRotation)) {
                yLabelRotation = scope.yLabelRotation;
            }

            if (angular.isDefined(scope.labelRotation)) {
                labelRotation = scope.labelRotation;
            }

            if (angular.isDefined(scope.labelOffset)) {
                labelOffset = scope.labelOffset;
            }

            if (angular.isDefined(scope.colors)) {
                colors = scope.colors;
            }

            if (angular.isDefined(scope.logoUrl)) {
                $(elm).children('.chart-header').prepend('<div><img class="logo" src="' + scope.logoUrl + '" /></div>');
            }

            elm.append('<div class="chart-hidden" id="' + hiddenID + '"></div>');

            scope.$watch('chartData', function (newVal) {
                if (angular.isArray(newVal) && newVal.length > 0) {

                    if (angular.isDefined(scope.highlightColor) && angular.isDefined(scope.highlightedItem)) {
                        // apply custom highlight color
                        angular.forEach(newVal, function(value, key) {
                            if (value.Category === scope.highlightedItem) {
                                value.color = scope.highlightColor;
                            } else {
                                value.color = colors[0];
                            }
                        });
                    }

                    if (angular.isDefined(scope.source)) {
                        source = scope.source;
                    }

                    if (chart === undefined) {
                        render();
                    }
                    chart.dataProvider = newVal;

                    // Set value axis properties
                    angular.forEach(chart.valueAxes, function (va) {
                        va.unit = unit;
                        va.unitPosition = unitPosition;
                        va.title = scope.yLabel;
                    });

                    chart.validateData();
                }
            });

            function render() {

                var config = {
                    "type": "serial",
                    "dataDateFormat": "YYYY-MM-DD HH:NN:SS",
                    "sequencedAnimation": false,
                    "categoryField": "Category",
                    "colors": colors,
                    "startDuration": .4,
                    "categoryAxis": {
                        "title": "",
                        "axisColor": "#E5E5E5",
                        "color": SETTINGS.CHARTS.TEXT.COLOR,
                        "gridThickness": 0,
                        "minHorizontalGap": 0,
                        "labelRotation": yLabelRotation,
                        "autoWrap": true
                    },
                    "graphs": [
                        {
                            "fillAlphas": 1,
                            "fillColors": SETTINGS.PALETTE[0],
                            "lineColor": SETTINGS.PALETTE[0],
                            "title": 'Unique Audience (000s)',
                            "type": "column",
                            "valueField": 'Unique Audience (000s)',
                            "valueAxis": "va1",
                            "labelText": '[[value]]' + unit,
                            "labelRotation": labelRotation,
                            "labelOffset" : labelOffset,
                            "labelColorField": "labelColor",
                            "fontSize": 11,
                            "showBalloon": false
                        },
                        {
                            "fillAlphas": 1,
                            "fillColors": SETTINGS.PALETTE[1],
                            "lineColor": SETTINGS.PALETTE[1],
                            "title": 'Time per person (hh:mm)',
                            "type": "column",
                            "valueField": 'Time per person (hh:mm)',
                            "valueAxis": "va2",
                            "labelText": '[[value]]',
                            "labelFunction": function (data) {

                                // Round hh:mm:ss to hh:mm
                                var bits = data.dataContext.time.split(':');
                                if (bits[2] > 30) {
                                    bits[1]++;
                                    if (bits[1] === 60) {
                                        bits[1] = 59;
                                        bits[0]++;
                                    }
                                }

                                return [bits[0], bits[1]].join(':');
                            },
                            "labelRotation": labelRotation,
                            "labelOffset" : labelOffset,
                            "labelColorField": "labelColor",
                            "fontSize": 11,
                            "showBalloon": false
                        }
                    ],
                    "balloon": {
                        "fixedPosition": false
                    },
                    "valueAxes": [
                        {
                            "id": 'va1',
                            "stackType": stacked ? "regular" : "none",
                            "gridThickness": 0,
                            "title": hideValueAxis ? '' : scope.yLabel,
                            "unit": showValueAxisUnit ? unit : '',
                            "unitPosition": unitPosition,
                            "axisColor": "#E5E5E5",
                            "color": SETTINGS.CHARTS.TEXT.COLOR,
                            "tickLength": hideValueAxis ? 0 : 5,
                            "labelsEnabled": !hideValueAxis,
                            "axisThickness": hideValueAxis ? 0 : 1,
                            "showFirstLabel": false,
                            "minimum": 0,
                            "maximum": maxValue
                        },
                        {
                            "id": 'va2',
                            "stackType": stacked ? 'regular' : 'none',
                            "position": 'right',
                            "gridThickness": 0,
                            "title": hideValueAxis ? '' : scope.yLabel,
                            "unit": showValueAxisUnit ? unit : '',
                            "unitPosition": unitPosition,
                            "axisColor": '#E5E5E5',
                            "color": SETTINGS.CHARTS.TEXT.COLOR,
                            "tickLength": hideValueAxis ? 0 : 5,
                            "axisThickness": hideValueAxis ? 0 : 1,
                            "labelsEnabled": !hideValueAxis,
                            "labelFunction": function (value) {

                                if (value === 0) {
                                    return '';
                                }

                                if (value < 10) {
                                    return '0' + value + ':00'
                                }
                                return value + ':00';
                            }
                        }
                    ],
                    "titles": [],
                    "legend": {
                        enabled: true,
                        useGraphSettings: true,
                        position: legendPosition,
                        align: legendAlign
                    },
                    "dataProvider": scope.chartData
                };

                if (!angular.isDefined(scope.colors) && hasOneSeries) {
                    config["colors"] = ['#75787b'];
                }

                chart = AmCharts.makeChart(scope.id + "_chart", config, 100);

                function exportChart() {

                    var exportConfig = {};

                    var hiddenDiv = angular.element(document.getElementById(hiddenID));
                    hiddenDiv.css({
                        width: exportW + 'px',
                        height: exportH + 'px'
                    });

                    // Copy visible chart config
                    angular.copy(config, exportConfig);

                    exportConfig.categoryAxis.labelRotation = 0;
                    exportConfig.categoryAxis.autoWrap = true;

                    exportConfig.autoMargins = false;
                    exportConfig.marginLeft = 100;
                    exportConfig.marginRight = 100;
                    exportConfig.marginTop = 50;
                    exportConfig.marginBottom = 100;

                    // Update data
                    exportConfig.dataProvider = scope.chartData;

                    if (angular.isDefined(scope.chartTitle)) {
                        exportConfig.marginTop += 50;
                    }

                    if (angular.isDefined(scope.subtitle)) {
                        exportConfig.marginTop += 30;
                    }

                    if (exportConfig.legend.position === 'bottom') {
                        exportConfig.legend.autoMargins = false;
                        exportConfig.legend.marginBottom = 70;
                    } else {
                        if (angular.isDefined(scope.footer)) {
                            exportConfig.marginBottom += 50;
                        }
                    }

                    exportConfig.export = {
                        enabled: true,
                        libs: {
                            autoLoad: false
                        },
                        menu: [],
                        afterCapture: function () {
                            var instance = this;

                            // Header rect
                            var headerRect = new fabric.Rect({
                                top: 10,
                                left: 0,
                                width: exportW,
                                height: 5,
                                fill: '#e4e8eb'
                            });
                            instance.setup.fabric.add(headerRect);

                            // Logo
                            var imgEl = document.querySelector('#chart-header-img');
                            if (imgEl !== null) {
                                var logo = new fabric.Image(imgEl, {
                                    left: exportW - imgEl.width - 40,
                                    top: 15
                                });
                                instance.setup.fabric.add(logo);
                            }

                            // Title
                            if (angular.isDefined(scope.chartTitle)) {
                                var title = new fabric.Text(scope.chartTitle.toUpperCase(), {
                                    left: 30,
                                    top: 40,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 18
                                });
                                title.left = 30;
                                instance.setup.fabric.add(title);
                            }

                            // Subtitle
                            if (angular.isDefined(scope.subtitle)) {
                                var subtitle = new fabric.Text(scope.subtitle, {
                                    left: 30,
                                    top: 80,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 15
                                });
                                subtitle.left = exportW/2 - subtitle.width/2;
                                instance.setup.fabric.add(subtitle);
                            }

                            // Footer
                            if (scope.footer) {
                                var footer = new fabric.Text(scope.footer, {
                                    left: 30,
                                    top: exportH - 50,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 10
                                });
                                instance.setup.fabric.add(footer);
                            }

                            // Source
                            var src = new fabric.Text('Source: ' + source, {
                                left: 30,
                                top: exportH - 60,
                                fontFamily: SETTINGS.FONT_FAMILY,
                                fontSize: 10
                            });
                            instance.setup.fabric.add(src);

                            // Copyright text
                            var footerText = new fabric.Text('Copyright © 2018 The Nielsen Company', {
                                left: 30,
                                top: exportH - 38,
                                fontFamily: SETTINGS.FONT_FAMILY,
                                fontSize: 10
                            });
                            instance.setup.fabric.add(footerText);

                            // Footer rect
                            var footerRect = new fabric.Rect({
                                top: exportH - 15,
                                left: 0,
                                width: exportW,
                                height: 5,
                                fill: '#e4e8eb'
                            });
                            instance.setup.fabric.add(footerRect);
                        }
                    };

                    hiddenChart = AmCharts.makeChart(hiddenID, exportConfig);

                    hiddenChart.export.capture({}, function () {
                        this.toPNG({}, function (data) {
                            this.download(data, this.defaults.formats.PNG.mimeType, scope.chartTitle);
                        });
                    });
                }

                scope.exportChart = exportChart;

                function downloadData() {
                    if (angular.isDefined(scope.chartDataKey)) {
                        DataFactory.download(scope.chartDataKey, scope.chartTitle);
                    }
                }

                scope.downloadData = downloadData;
            }
        }
    }
})();